import setupForm from './form-ebook.js'

// Attach the function to the window object
window.setupForm = setupForm
